const EyeIcon = () => (
    <svg width="14" className="inline-block" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7 7.33341C10.3137 7.33341 13 4.00008 13 4.00008C13 4.00008 10.3137 0.666748 7 0.666748C3.6863 0.666748 1 4.00008 1 4.00008C1 4.00008 3.6863 7.33341 7 7.33341Z" stroke="#FF38A4" strokeWidth="1.33333" strokeLinejoin="round" />
        <path d="M7.00008 5.33341C7.73645 5.33341 8.33341 4.73645 8.33341 4.00008C8.33341 3.26371 7.73645 2.66675 7.00008 2.66675C6.26371 2.66675 5.66675 3.26371 5.66675 4.00008C5.66675 4.73645 6.26371 5.33341 7.00008 5.33341Z" stroke="#FF38A4" strokeWidth="1.33333" strokeLinejoin="round" />
    </svg>

);
export default EyeIcon;
